@if (this.games) {
  <div >
    <h3 style="display: flex; align-items: center;">
      <mat-icon>sports_hockey</mat-icon>
      LATEST GAMES
    </h3>
    @for (game of this.games; track game) {
      <div>
        @if (game.MyTeamId==game.HomeTeamId) {
          <div  style="display: flex; flex-direction: row;  overflow-x: hidden; height: 22px;">
            <div style=" width: 50px;">
              <!--  <img [src]="'/assets/img' + this.game.AwayTeam.SmallIconFileName" class="teamlogo_forgame" /> -->
              {{game.EventDate | date:'dd/M'}}
            </div>
            <div style="width: 100px; overflow-x: hidden;text-wrap: nowrap;">
              {{game.AwayTeam.Name}}
            </div>
            @if (game.GameStatistics.IsFinalScore && game.GameStatistics.GoalsHome<game.GameStatistics.GoalsAway) {
              <div  class="gameloss">
                {{game.GameStatistics.GoalsHome}}-{{game.GameStatistics.GoalsAway}}
              </div>
            }
            @if (game.GameStatistics.IsFinalScore && game.GameStatistics.GoalsHome>game.GameStatistics.GoalsAway) {
              <div  class="gamewin">
                {{game.GameStatistics.GoalsHome}}-{{game.GameStatistics.GoalsAway}}
              </div>
            }
            @if (game.GameStatistics.IsFinalScore && game.GameStatistics.GoalsHome==game.GameStatistics.GoalsAway) {
              <div  class="gamedraw">
                {{this.game.GameStatistics.GoalsHome}}-{{this.game.GameStatistics.GoalsAway}}
              </div>
            }
            @if (!game.GameStatistics.IsFinalScore) {
              <div style="width: 50px;">
              </div>
            }
            <!--    <div style="width: 50px; overflow-x: hidden; text-wrap: nowrap; font-weight: bold;" *ngIf="this.game.GameStatistics.IsFinalScore">
            {{this.game.GameStatistics.GoalsHome}}-{{this.game.GameStatistics.GoalsAway}}
          </div> -->
          <div style="margin-left: 10px;">
            @if (game.OverallAvg > 0) {
              <div [class]="getPlayerGradeClass(game.OverallAvg)" style="display: flex; flex-direction: row; align-items: center;">
                <mat-icon style="font-size: medium;">people</mat-icon>
                <div>{{game.OverallAvg | number:'1.2-2'}} ({{game.RankingNoOfBad + game.RankingNoOfNeutral + game.RankingNoOfGood + game.RankingNoOfVeryGood + game.RankingNoOfExcellent }})</div>
              </div>
            }
          </div>
          <div class="coachassessment">
            @for (assessment of game.PlayerRankingSummaryByScout; track assessment) {
              <div class="assessment" [class]="getCoachGradeClass(assessment.AverageRanking)">
                {{assessment.ScoutFirstName | slice: 0:1}}{{assessment.ScoutLastName | slice: 0:1}}:&nbsp;{{assessment.AverageRanking | number:'1.2-2' }}
              </div>
            }
          </div>
        </div>
      }
      @if (game.MyTeamId!=game.HomeTeamId) {
        <div style="display: flex; flex-direction: row; overflow-x: hidden; height: 22px;">
          <div style="width: 50px;">
            <!-- <img [src]="'/assets/img' + this.game.HomeTeam.SmallIconFileName" class="teamlogo_forgame"   /> -->
            {{game.EventDate | date:'dd/M'}}
          </div>
          <div style="width: 100px; overflow-x: hidden; text-wrap: nowrap;">
            {{game.HomeTeam.Name}}
          </div>
          <!--             <div style="width: 50px; overflow-x: hidden; text-wrap: nowrap; font-weight: bold;" *ngIf="game.GameStatistics.IsFinalScore">
          {{game.GameStatistics.GoalsHome}}-{{game.GameStatistics.GoalsAway}}
        </div> -->
        @if (game.GameStatistics.IsFinalScore && game.GameStatistics.GoalsHome>game.GameStatistics.GoalsAway) {
          <div class="gameloss" >
            {{game.GameStatistics.GoalsHome}}-{{game.GameStatistics.GoalsAway}}
          </div>
        }
        @if (game.GameStatistics.IsFinalScore && game.GameStatistics.GoalsHome<game.GameStatistics.GoalsAway) {
          <div class="gamewin">
            {{game.GameStatistics.GoalsHome}}-{{game.GameStatistics.GoalsAway}}
          </div>
        }
        @if (game.GameStatistics.IsFinalScore && game.GameStatistics.GoalsHome==game.GameStatistics.GoalsAway) {
          <div class="gamedraw">
            {{game.GameStatistics.GoalsHome}}-{{game.GameStatistics.GoalsAway}}
          </div>
        }
        @if (!game.GameStatistics.IsFinalScore) {
          <div style="width: 50px;">
          </div>
        }
        <div style="margin-left: 10px;">
          @if (game.OverallAvg > 0) {
            <div [class]="getPlayerGradeClass(game.OverallAvg)" style="display: flex; flex-direction: row; align-items: center;">
              <mat-icon style="font-size: medium;">people</mat-icon>
              <div>
                {{game.OverallAvg | number:'1.2-2'}} ({{game.RankingNoOfBad + game.RankingNoOfNeutral + game.RankingNoOfGood + game.RankingNoOfVeryGood + game.RankingNoOfExcellent }})
              </div>
            </div>
          }
        </div>
        <div  class="coachassessment">
          @for (assessment of game.PlayerRankingSummaryByScout; track assessment) {
            <div class="assessment"  [class]="getCoachGradeClass(assessment.AverageRanking)">
              {{assessment.ScoutFirstName | slice: 0:1}}{{assessment.ScoutLastName | slice: 0:1}}:&nbsp;{{assessment.AverageRanking | number:'1.2-2' }}
            </div>
          }
        </div>
      </div>
    }
  </div>
}
@if (games.length===0) {
  <div style="margin-left: 30px; color: darkgray;">
    NO GAMES FOUND
  </div>
}
@if (games.length>0) {
  <button mat-stroked-button [routerLink]="['/load/game_feed/', this.Team.TeamId]">VIEW DETAILS</button>
}
<!--     <button mat-stroked-button [routerLink]="['/performance/gamecharts//', this.Team.TeamId]">VIEW CHARTS</button>
-->
</div>
}

